import { Ticker } from 'pixi.js';

const ticker = new Ticker();
ticker.totalTime = 0;
ticker.add(() => {
  ticker.totalTime += ticker.deltaTime; // Time is already scale by speed (?)
});

export default ticker;
